<template>
  <transition-group name="slide-in" class="relative overflow-hidden rounded-lg">
    <template v-for="investment in sortedData">
      <template v-if="investment.type === 'PORTFOLIO'">
        <div :key="investment.investment_id" class="relative h-full w-full">
          <new-list-strategy-row-component
            :key="investment.investment_id"
            type="portfolio-master"
            :investment="investment"
            :nameColSpan="nameColSpan"
            :headers="headers"
            class="cursor-pointer filter transition-all hover:brightness-90 dark:hover:brightness-110"
            @click.native="setOpenPortfolio(investment.investment_id)"
            @toggleSwitch="toggleSwitch"
          />

          <template v-if="openPortfolios.includes(investment.investment_id)">
            <new-list-strategy-row-component
              v-for="component in investment.sub_strategies"
              type="portfolio-component"
              :key="component.investment_id"
              :investment="component"
              :nameColSpan="nameColSpan"
              :headers="headers"
            />
          </template>
          <card-mask-component
            v-for="(mask, mask_index) in investment.masks_list"
            :key="mask_index + mask.type"
            :mask="mask"
            @click.native="closeMask(investment.investment_id, mask)"
          />
        </div>
      </template>
      <div v-else :key="investment.investment_id" class="relative">
        <new-list-strategy-row-component
          :investment="investment"
          :nameColSpan="nameColSpan"
          :headers="headers"
          @toggleSwitch="toggleSwitch"
        />
        <card-mask-component
          v-for="(mask, mask_index) in investment.masks_list"
          :key="mask_index + mask.type"
          :mask="mask"
          @click.native="closeMask(investment.investment_id, mask)"
        />
      </div>
    </template>
  </transition-group>
</template>

<script>
import event_bus from "../../../../../shared/utils/event_bus";
import { mapActions } from "vuex";
export default {
  components: {
    newListStrategyRowComponent: () =>
      import("./new-list-strategy-row.component.vue"),
    CardMaskComponent: () =>
      import("../card-investment/card-mask/card-mask.component.vue"),
  },
  props: {
    investments: {
      type: Array,
    },
    nameColSpan: {
      type: Number,
    },
    headers: {
      type: Array,
    },
  },

  data() {
    return {
      show: false,
      openPortfolios: [],
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.investments.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.investments.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.investments;
      }
    },
  },

  methods: {
    ...mapActions({
      removeMask: "investment/removeMask",
    }),
    setOpenPortfolio(id) {
      if (this.openPortfolios.includes(id)) {
        this.openPortfolios.splice(
          this.openPortfolios.findIndex((item) => item === id),
          1
        );
      } else {
        this.openPortfolios.push(id);
      }
    },
    toggleSwitch({ investmentId, investmentStatus, toggle }) {
      if (!toggle) {
        this.$emit("electronicSignature", { investmentId, investmentStatus });
      }
    },
    closeMask(investment_id, mask) {
      this.removeMask({
        investment_id,
        mask,
      });
      if (mask.fixedMask) {
        this.$api
          .post(this.$endpoint.DISMISS_MASK, {
            investment_id: investment_id,
            notification_type: mask.type,
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },

  mounted() {
    event_bus.$on(
      "SET_INVESTMENT_LIST_FILTER",
      ({ sortDirection, sortKey }) => {
        this.sortKey = sortKey;
        this.sortDirection = sortDirection;
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.slide-in {
  &-enter-active,
  &-leave-active {
    @apply h-8 transition-all duration-300 ease-in-out;
  }
  &-enter,
  &-leave-to {
    @apply h-0 -translate-y-full transform opacity-0;
  }
  &-move {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
